import React from "react";
export class SignUpSuccess extends React.Component {
  render() {
    return <div>Success</div>;
  }
}
